export const variable = {
  // Color Variables
  black: '#000000',
  white: '#FFFFFF',
  orange: '#FFA500',

  primaryColor: '#0071d1',
  secondaryColor: '#35373b',
  tertiaryColor: '#282a2f',
  dark: '#222429',
  darker: '#0f0f13',
  darkest: '#181a1d',
  backdropColor: "#8e8e8e24",

  // border Colors
  borderColor: '#414143',

  // Text Color
  error: '#F44336',
  warning: '#f57c00',
  textColor: '#797a7d',

  iconColor: '#797a7d',

  // FontSizes Variables
  f1: '0.875em',
  f2: '0.9em',
  f3: '1em',
  f4: '1.2em',
  f5: '1.4em',
  f6: '1.6em',
  f7: '1.8em',

  // Icon FontSize
  sizeLarge: '2.4rem',
  sizeMedium: '2rem',
  sizeSmall: '1.8rem',

}